export default __webpack_public_path__ + "static/media/Pretendard-ExtraLight.subset.45216768.woff2";